import React from 'react'
import './Portfolio.css'
import { Swiper, SwiperSlide } from 'swiper/react'
import Sidebar from "../../img/sidebar.png";
import Ecommerce from "../../img/ecommerce.png";
import HOC from "../../img/hoc.png";
import MusicApp from "../../img/musicapp.png";
import Portfoliot from "../../img/portfoliot.jpeg";
import Portfoliot2 from "../../img/portfoliot2.jpeg";
import 'swiper/css';
import { themeContext } from '../../Context';
import { useContext } from 'react';
//  firstly - yarn add swiper 
const Portfolio = () => {
    const theme = useContext(themeContext)
    const darkMode = theme.state.darkMode
    return (
        <div className="portfolio" id='Portfolio'>
            {/* Heading */}
            <span style={{color: darkMode? 'white': ''}}>Recent Project</span>
            <span>Portfolio</span>

            {/* Slider */}
            <Swiper
                spaceBetween={30}
                slidesPerView={3}
                grabCursor={true}
                className='portfolio-slider'
            >
                <SwiperSlide>
                    <img src={Sidebar} alt="" />
                </SwiperSlide>
                <SwiperSlide>
                    <img src={Ecommerce} alt="" />
                </SwiperSlide>
                <SwiperSlide>
                    <img src={Portfoliot2} alt="" className="portfoliot2" />
                </SwiperSlide>
                <SwiperSlide>
                    <img src={MusicApp} alt="" />
                </SwiperSlide>
                <SwiperSlide>
                    <img src={HOC} alt="" />
                </SwiperSlide>
                <SwiperSlide>
                    <img src={Portfoliot} alt="" className="portfoliot"/>
                </SwiperSlide>
            </Swiper>
        </div>
    )
}

export default Portfolio

